import { render } from "./CadastroChamadosView.vue?vue&type=template&id=2260f860&scoped=true"
import script from "./CadastroChamadosView.vue?vue&type=script&lang=js"
export * from "./CadastroChamadosView.vue?vue&type=script&lang=js"

import "./CadastroChamadosView.vue?vue&type=style&index=0&id=2260f860&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LAF\\Desktop\\GARANTEPAY\\PROJETOS\\WORKFLOW\\FrontVue-main\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2260f860"]])

export default __exports__